import React, {CSSProperties} from 'react';
import {globalColor} from "styles/global";
import {useLocation, useNavigate} from "react-router-dom";


const button: CSSProperties = {
    padding: 10,
    color: 'white',
}

const selected: CSSProperties = {
    color: globalColor.primaryGreen
}

export default function NavBar() {
    const location = useLocation();
    const navigate = useNavigate();

    function getStyle(buttonName: string): CSSProperties {
        let style: CSSProperties = button;
        if (location.pathname.startsWith('/' + buttonName)) {
            return {...style, ...selected};
        }
        return style;
    }

    return (
        <div className={"row navbar"}>
            <button
                style={getStyle('home')}
                onClick={() => navigate('/home')}
            >
                Home
            </button>
            <button
                style={getStyle('work')}
                onClick={() => navigate('/work')}
            >
                Work
            </button>
        </div>
    )
}